import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { QuestionnairesGridStore } from '../../../store/questionnairesGrid-store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuestionnaireCategory } from 'src/app/models/questionnaireCategory.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { GlobalStore } from 'src/app/store/global-store';
import { CreateDistributionGroupComponent } from 'src/app/features/users/components/create-distribution-group/create-distribution-group';
import { Reminder } from 'src/app/models/reminder';
import { Recipients } from 'src/app/models/recipients.model';
import { ChooseRecipientsComponent } from 'src/app/features/users/components/choose-recipients/choose-recipients.component';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { MatDialog } from '@angular/material/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { SaveNameListComponent } from 'src/app/features/create-questionnaire-page/component/question-form/components/save-name-list/save-name-list.component';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { QuestionnaireRow } from 'src/app/models/questionnaireGrid.model';
import { environment } from 'src/environment';

@Component({
    selector: 'que-questionnaires-files',
    imports: [RouterLink, CommonModule, FormsModule, ReactiveFormsModule, TranslateDirective, TranslatePipe, OverlayModule],
    templateUrl: './questionnaires-files.component.html',
    styleUrls: ['./questionnaires-files.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionnairesFilesComponent implements OnInit {
  @Input() isOpen = true;
  #router = inject(Router);
  #globalStore = inject(GlobalStore);
  #questonnaireService = inject(QuestionnaireApiService);
  #questonnaireGridStore = inject(QuestionnairesGridStore);
  #manipulationToolbar = inject(ManipulationsToolbarStore);
  isAdmin$ = toSignal(this.#globalStore.isRoleAdmin$);
  isApproverManager$ = toSignal(this.#globalStore.isApproverManager$);
  isDisplayApproval$ = toSignal(this.#globalStore.isDisplayApprovals$);
  countApprovals$ = toSignal(this.#globalStore.countApprovals$);
  #dialog = inject(MatDialog);
  environment = environment;
  // questionnaires$ = toSignal(this.#questionnairesStore.questionnaires$);
  // categories$ = toSignal(this.#questionnairesStore.categories$);
  // categoryId = 0;
  lastUrlSegment = "";

  private updateLastUrlSegment(url: string): void {
    const segments = url.split('/');
    this.lastUrlSegment = segments[segments.length - 1];
  }
  ngOnInit(): void {
    // Subscribe to router events
    this.#router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateLastUrlSegment(event.url);
      }
    });

    // Get the initial route snapshot and set lastUrlSegment
    this.updateLastUrlSegment(this.#router.url);
  }
  createNewOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];

  createNewQuestionnaire() {
    this.#questonnaireService.createQuestionnaire().subscribe(
      questionnaire => {
        this.#questonnaireGridStore.addNewQuestionnaire(questionnaire)
        this.#router.navigate([`create/${questionnaire.id}`])
      }
    )
  }

  newReminder() {
    this.createNewOpen = false;
    this.#dialog.open(ChooseRecipientsComponent,
      {
        data: { name: this.#globalStore.isHeSignal$() ? "שם התזכורת" : "The name of the reminder", isReminder: true, isCreated: true },
        autoFocus: false,
        position: { top: '6%' },
        panelClass: 'dialog-panel'
      })
      .afterClosed().subscribe((result) => {
        if (result) {
          const [recipients, reminderForm, mailForm, event] = result;
          if ((recipients || mailForm) && event) {
            if (event == 'create') {
              var r = recipients as Recipients;
              this.#globalStore.createReminder(
                {
                  id: 0, recipients: r, subject: mailForm?.subject, content: mailForm?.body,
                  startDate: reminderForm?.startDate, frequencyId: reminderForm?.frequencyId,
                  endDate: reminderForm?.endDate, isApproval: reminderForm?.isApproval,
                  hour: reminderForm?.hour
                } as Reminder)
            }
          }
          // hourId: new FormControl<number>(23),
        }
      })
  }
  newDistrbutionGroup() {
    this.createNewOpen = false;
    this.#dialog.open(CreateDistributionGroupComponent,
      {
        data: { isCreate: true },
        autoFocus: false,
        position: { top: '8%' },
        panelClass: 'dialog-panel'
      })
      .afterClosed().subscribe((result) => {
        if (result) {
          const [groupName, recipients, color, groupType] = result;
          if ((recipients)) {
            this.#globalStore.createDistributionGroup(
              {
                name: groupName,
                users: recipients,
                color,
                groupType
              } as DistributionGroup)
          }
        }

      })
  }

  newSavedList() {
    this.createNewOpen = false;
    this.#dialog.open(SaveNameListComponent,
      {
        data: { withItems: true, isCreate: true },
        autoFocus: false,
      }
    ).afterClosed()
      .subscribe(resultFromPopUp => {
        if (resultFromPopUp) {
          this.#globalStore.createCollectionList(resultFromPopUp);
        }
      })
  }
  navigate(route: string) {
    //restart the global manipulation filters of questionnaires 
    if (this.lastUrlSegment != route) {

      if (this.lastUrlSegment == "questionnaires") {
        this.#manipulationToolbar.resetAllFilters();
      }

      this.#router.navigate(['main', 'grid', route]);

    }
  }
}
